// Debounced refreshCartUI — collapses rapid calls into one fetch
var _refreshCartTimer = null;
var _refreshCartResolvers = [];
function refreshCartUI() {
  return new Promise(function(resolve) {
    _refreshCartResolvers.push(resolve);
    clearTimeout(_refreshCartTimer);
    _refreshCartTimer = setTimeout(async function() {
      var resolvers = _refreshCartResolvers.splice(0);
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        try {
          var sectionIds = cartDrawer.getSectionsToRender()
            .map(function(s) { return s.id; })
            .filter(function(v, i, a) { return a.indexOf(v) === i; });
          var data = await fetch(window.location.pathname + '?sections=' + sectionIds.join(','))
            .then(function(r) { return r.json(); });
          cartDrawer.renderContents({ sections: data });
          resolvers.forEach(function(r) { r(); });
          return;
        } catch(e) { console.error('refreshCartUI error:', e); }
      }
      window.location.reload();
    }, 300);
  });
}

// Event delegation — all handlers survive DOM replacement by renderContents
document.addEventListener('click', async function(e) {

  // Clear cart
  if (e.target.closest('#clear-cart')) {
    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      await refreshCartUI();
    } catch (err) {
      console.error('Failed to clear cart:', err);
    }
    return;
  }

  // Remove bundle or single item
  const removeBtn = e.target.closest('.cart-bundle-remove');
  if (removeBtn) {
    const originalText = removeBtn.textContent;
    removeBtn.textContent = '...';
    const bundleId = removeBtn.dataset.bundleId;
    const lineKey = removeBtn.dataset.lineKey;

    if (bundleId) {
      const bundleGroup = removeBtn.closest('.cart-bundle-group');
      const lineKeys = {};
      const parentInput = bundleGroup.querySelector('.cart-bundle-parent .cart-qty-input');
      if (parentInput) lineKeys[parentInput.dataset.lineKey] = 0;
      bundleGroup.querySelectorAll('.cart-bundle-child').forEach(function(child) {
        lineKeys[child.dataset.lineKey] = 0;
      });
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: lineKeys }),
        });
        await refreshCartUI();
      } catch (err) {
        console.error('Failed to remove bundle:', err);
        removeBtn.textContent = originalText;
      }
    } else if (lineKey) {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { [lineKey]: 0 } }),
        });
        await refreshCartUI();
      } catch (err) {
        console.error('Failed to remove item:', err);
        removeBtn.textContent = originalText;
      }
    }
    return;
  }

  // Bundle increase
  const increaseBundle = e.target.closest('.cart-bundle-group .cart-qty-increase');
  if (increaseBundle) {
    const originalText = increaseBundle.innerHTML;
    increaseBundle.innerHTML = '...';
    increaseBundle.disabled = true;
    const bundleGroup = increaseBundle.closest('.cart-bundle-group');
    const updates = {};
    const parentInput = bundleGroup.querySelector('.cart-bundle-parent .cart-qty-input');
    const currentQty = parseInt(parentInput.value);
    if (parentInput) updates[parentInput.dataset.lineKey] = currentQty + 1;
    bundleGroup.querySelectorAll('.cart-bundle-child').forEach(function(child) {
      updates[child.dataset.lineKey] = currentQty + 1;
    });
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      await refreshCartUI();
    } catch (err) {
      console.error('Failed to increase bundle quantity:', err);
      increaseBundle.innerHTML = originalText;
      increaseBundle.disabled = false;
    }
    return;
  }

  // Bundle decrease
  const decreaseBundle = e.target.closest('.cart-bundle-group .cart-qty-decrease');
  if (decreaseBundle) {
    const originalText = decreaseBundle.innerHTML;
    decreaseBundle.innerHTML = '...';
    decreaseBundle.disabled = true;
    const bundleGroup = decreaseBundle.closest('.cart-bundle-group');
    const updates = {};
    const parentInput = bundleGroup.querySelector('.cart-bundle-parent .cart-qty-input');
    const currentQty = parseInt(parentInput.value);
    if (parentInput) updates[parentInput.dataset.lineKey] = currentQty - 1;
    bundleGroup.querySelectorAll('.cart-bundle-child').forEach(function(child) {
      updates[child.dataset.lineKey] = currentQty - 1;
    });
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      await refreshCartUI();
    } catch (err) {
      console.error('Failed to decrease bundle quantity:', err);
      decreaseBundle.innerHTML = originalText;
      decreaseBundle.disabled = false;
    }
    return;
  }

  // Single increase (add-ons / standalone)
  const singleIncrease = e.target.closest('.single-increase');
  if (singleIncrease) {
    const originalText = singleIncrease.innerHTML;
    singleIncrease.innerHTML = '...';
    singleIncrease.disabled = true;
    const wrapper = singleIncrease.closest('.bundle-qty-wrapper') || singleIncrease.closest('.cart-item-standalone__qty');
    const currentInp = wrapper.querySelector('.cart-qty-input, .cart-item-standalone__qty-input');
    const currentQty = parseInt(currentInp.value);
    const updates = {};
    if (currentInp) updates[currentInp.dataset.lineKey] = currentQty + 1;
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      await refreshCartUI();
    } catch (err) {
      console.error('Failed to increase quantity:', err);
      singleIncrease.innerHTML = originalText;
      singleIncrease.disabled = false;
    }
    return;
  }

  // Single decrease (add-ons / standalone)
  const singleDecrease = e.target.closest('.single-decrease');
  if (singleDecrease) {
    const originalText = singleDecrease.innerHTML;
    singleDecrease.innerHTML = '...';
    singleDecrease.disabled = true;
    const wrapper = singleDecrease.closest('.bundle-qty-wrapper') || singleDecrease.closest('.cart-item-standalone__qty');
    const currentInp = wrapper.querySelector('.cart-qty-input, .cart-item-standalone__qty-input');
    const currentQty = parseInt(currentInp.value);
    const updates = {};
    if (currentInp) updates[currentInp.dataset.lineKey] = currentQty - 1;
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      await refreshCartUI();
    } catch (err) {
      console.error('Failed to decrease quantity:', err);
      singleDecrease.innerHTML = originalText;
      singleDecrease.disabled = false;
    }
    return;
  }
});
